import type { UserInfoResponse } from '@chat-types/model/user/UserInfoResponse';
import Icon from '@components/common/Icon';
import Chips from '@components/common/chips/Chips';
import * as SC from '@components/channelList/UserChipItem.style';

type ChipItemProps = {
  user: UserInfoResponse;
  index: number;
  onClickDelete: (user: UserInfoResponse) => void;
};

const UserChipItem = ({ user, index, onClickDelete }: ChipItemProps) => {
  return (
    <SC.Container title={user.userName}>
      <Chips key={`chips__${user.userId}${index}`} targetId={user.userId}>
        {/* <Avatar
                    width="24px"
                    height="24px"
                    src={user?.userRegImg || ''}
                /> */}
        <Chips.Label label={user.userName} className="user-selected-label" />
        <Chips.Icon
          onClick={() => {
            onClickDelete(user);
          }}
        >
          <Icon icon="IcDelete" size="16px" />
        </Chips.Icon>
      </Chips>
    </SC.Container>
  );
};

export default UserChipItem;
